<template>
    <v-dialog  v-model="dialogNewService" width="800" persistent >
        <v-stepper v-model="e1">
            <v-stepper-header>
                <v-stepper-step :complete="e1 > 1" step="1">Customer Information</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="e1 > 2" step="2">Lumpers</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="e1 > 3" step="3">Details</v-stepper-step>
            </v-stepper-header>
            <v-stepper-items>
                <v-stepper-content step="1">
                    <v-card >
                        <v-form ref="form" v-model="valid" lazy-validation >
                            <v-container>
                                <v-row>
                                    <v-col cols="12" md="4" >
                                        <v-select item-value="idCustomer" item-text="name" v-model="serviceModel.idCustomer" :items="items" :rules="[v => !!v || 'Customer is required']"
                                            label="Customer"
                                            required
                                            :disabled="seeService"
                                            @change="selectCustomer()"
                                        ></v-select>
                                    </v-col>
                                    <v-col cols="12" md="4" >
                                        <v-text-field disabled v-model="address"  label="Address" required ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="2" >
                                        <v-text-field disabled v-model="phoneNumber"  label="Phone Number" required ></v-text-field>
                                    </v-col><v-col cols="12" md="2" >
                                        <v-text-field disabled v-model="postalCode"  label="Postal Code" required ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="6" >
                                         <v-combobox
                                            v-model="serviceModel.location"
                                            :items="itemsLocation"
                                            :search-input.sync="search"
                                            hide-selected
                                            label="Select or create location"
                                            persistent-hint
                                            :rules="LocationRules"
                                        >
                                            <template v-slot:no-data>
                                            <v-list-item>
                                                <v-list-item-content>
                                                <v-list-item-title>
                                                    No results matching "<strong>{{ search }}</strong>". Press <kbd>Tab</kbd> to create a new location and continue.
                                                </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                            </template>
                                        </v-combobox>
                                    </v-col>
                                    <v-col cols="12" md="6" >
                                        <v-select item-value="ServiceTypeId" item-text="name" v-model="serviceType" :items="serviceTypes" :rules="[v => !!v || 'Service is required']"
                                            label="Service"
                                            required
                                            @change="selectService()"
                                        ></v-select>
                                    </v-col>
                                </v-row> 
                                <v-row>
                                    <v-col cols="12" sm="6" md="4">
                                        <v-menu
                                            v-model="menu2"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                            <v-text-field
                                                v-model="serviceModel.date"
                                                label="Date"
                                                prepend-icon="event"
                                                readonly
                                                v-on="on"
                                            ></v-text-field>
                                            </template>
                                            <v-date-picker v-model="serviceModel.date" @input="menu2 = false"></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="4">
                                        <v-menu
                                            ref="menuTime"
                                            v-model="timePicker"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            :return-value.sync="serviceModel.startTime"
                                            transition="scale-transition"
                                            offset-y
                                            max-width="290px"
                                            min-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                            <v-text-field
                                                :rules="TimeRules"
                                                v-model="serviceModel.startTime"
                                                label="Start Time"
                                                prepend-icon="access_time"
                                                readonly
                                                v-on="on"
                                                @change="updateStatTime()"
                                            ></v-text-field>
                                            </template>
                                            <v-time-picker
                                            color="blue darken-3"
                                            v-if="timePicker"
                                            v-model="serviceModel.startTime"
                                            full-width
                                            @click:minute="$refs.menuTime.save(serviceModel.startTime)"
                                            ></v-time-picker>
                                        </v-menu>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-form>
                    </v-card> 
                    <v-card-actions class="pt-4">
                        <v-btn class="white--text" color="blue darken-3" @click="toStep2()">
                            Continue 
                            <v-icon small right>fas fa-angle-right</v-icon>
                            </v-btn>
                        <v-btn text @click="closeDialogNewService()" class="white--text" color="error" outlined>Cancel</v-btn>
                    </v-card-actions>
                </v-stepper-content>

                <v-stepper-content step="2">
                    <v-card>
                        <v-data-table
                            :headers="headers"
                            :items="serviceModel.travelWorkers"
                            sort-by="calories"
                            class="elevation-1"
                        >
                            <template v-slot:top>
                            <v-toolbar flat color="white">
                                <v-toolbar-title>Workers</v-toolbar-title>
                                <v-divider class="mx-4" inset vertical></v-divider>
                                <v-spacer></v-spacer>
                                <!--DIALOG PARA AGREGAR WORKER -->
                                <v-dialog v-model="dialog" max-width="400px">
                                <template v-slot:activator="{ on }">
                                    <v-btn color="blue darken-3" dark class="mb-2" v-on="on" @click="openDialoAddWorker()">Add Lumper</v-btn>
                                </template>
                                <v-card>
                                    <v-card-title>
                                    <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>
                                    <v-card-text>
                                    <v-container>
                                        <v-row>
                                            <v-col cols="12" sm="6" md="8" >
                                                <v-select item-value="id" item-text="name" v-model="editedItem.userId" :items="itemsWorkers" :rules="[v => !!v || 'Worker is required']"
                                                    label="Worker"
                                                    required
                                                    :disabled="editWorker"
                                                    @change="selectWorker()"
                                                ></v-select>
                                            </v-col>
                                            <v-col cols="12" sm="6" md="4">
                                                <v-text-field disabled v-model="editedItem.phone" label="Phone Number"></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" sm="4" md="4">
                                                <v-text-field type="Number" v-model="editedItem.hours" label="Hours"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="4" md="4">
                                                <v-text-field type="Number" v-model="editedItem.rate" label="Rate"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="4" md="4">
                                                <v-menu
                                                    ref="menuTime2"
                                                    v-model="timePicker2"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    :return-value.sync="editedItem.startTime"
                                                    transition="scale-transition"
                                                    offset-y
                                                    max-width="290px"
                                                    min-width="290px"
                                                >
                                                    <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                        v-model="editedItem.startTime"
                                                        label="Start Time"
                                                        prepend-icon="access_time"
                                                        readonly
                                                        v-on="on"
                                                    ></v-text-field>
                                                    </template>
                                                    <v-time-picker
                                                    v-if="timePicker2"
                                                    v-model="editedItem.startTime"
                                                    full-width
                                                    @click:minute="$refs.menuTime2.save(editedItem.startTime)"
                                                    ></v-time-picker>
                                                </v-menu>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                    </v-card-text>
                                    <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="error" outlined text @click="close">Cancel</v-btn>
                                    <v-btn color="success" outlined text @click="save">{{textButtonWorker}} </v-btn>
                                    </v-card-actions>
                                </v-card>
                                </v-dialog>
                            </v-toolbar>
                            </template>
                            <template v-slot:item.actions="{ item }">
                            <v-icon small class="mr-2" @click="editItem(item)">
                                far fa-edit
                            </v-icon>
                            <v-icon small @click="deleteItem(item)" >
                                far fa-trash-alt
                            </v-icon>
                            </template>
                        </v-data-table>
                    </v-card> 
                    <v-card-actions>
                        <v-btn class="mr-4 white--text" color="blue darken-3" @click="toStep3()">
                            Continue 
                            <v-icon small right>fas fa-angle-right</v-icon>
                        </v-btn>
                        <v-btn class="mr-4 white--text" color="blue" @click="e1 = 1">
                            <v-icon small left>
                                fas fa-angle-left
                            </v-icon>
                            Previous 
                        </v-btn>
                        <v-btn text @click="closeDialogNewService()" class="white--text" outlined color="error">Cancel</v-btn>
                    </v-card-actions>
                </v-stepper-content>

                <v-stepper-content step="3">
                    <v-card >
                        <v-form ref="form2" v-model="valid2" :lazy-validation="lazy2" >
                        <v-row>
                            <v-col cols="12" sm="6" md="3">
                                <v-text-field  v-model="serviceModel.travelDetail.po" label="PO" ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-text-field  v-model="serviceModel.travelDetail.truck" label="Truck" ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-text-field  v-model="serviceModel.travelDetail.trucking_Co" label="Trucking CO" ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-text-field  v-model="serviceModel.travelDetail.trailer" label="Trailer" ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="6" md="2">
                                <v-text-field  v-model="serviceModel.travelDetail.containerSize" label="Container size" ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="5">
                                <v-text-field  v-model="serviceModel.travelDetail.description" label="Description" ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="5">
                                <v-text-field  v-model="serviceModel.travelDetail.driver" label="Driver" ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <v-text-field  v-model="serviceModel.travelDetail.authorizedBy" label="Authorized By" ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-text-field  v-model="serviceModel.travelDetail.otherField" label="Field Name" ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-text-field  v-model="serviceModel.travelDetail.otherFieldValue" label="Field Value" ></v-text-field>
                            </v-col>
                        </v-row>
                        </v-form>
                    </v-card>
                    <v-card-actions class="pt-4">
                        <v-btn v-if="stateService=== '1'  || stateService=== '2' || stateService=== '3' && serviceInfo.invoice===null" class="white--text" color="blue darken-3" @click="SaveService()">
                            {{textButtonSaveService}}
                            <v-icon right small>save</v-icon>
                        </v-btn>
                        <v-btn class="mr-4 white--text" color="blue" @click="e1 = 2"> 
                            <v-icon small left>
                                fas fa-angle-left
                            </v-icon>
                            Previous 
                        </v-btn>
                        <v-btn color="error" class="mr-4" text @click="closeDialogNewService()">Cancel</v-btn>
                    </v-card-actions>
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>
    </v-dialog>
</template>

<script>
import {showMessageError,showMessageSuccess,showMessageWarning} from '../../services/sweetAlert'
export default {
    data () {
      return {
        editWorker: false,
        search:null,
        e1: 1,
        valid: true,
        valid2:true,
        lazy2:false,
        postalCode:0,
        address: '',
        phoneNumber:'',
        serviceType:'',
        LocationRules: [
            v => !!v || 'Location is required',
        ],
        TimeRules: [
            v => !!v || 'Start time is required',
        ],
        fieldRules: [
            v => !!v || 'This field is required',
            //v => (v && v.length <= 10) || 'Service must be less than 5 characters',
        ],
        email: '',
        emailRules: [
            v => !!v || 'E-mail is required',
            v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        ],
        select: null,
        items: [],
        itemsLocation: [],
        itemsWorkers: [],
        checkbox: false,
        service:'Swamping/Lumping',
        serviceModel : {
            'idTravel':0,
            'idCustomer': 0,
            'location': '',
            serviceTypeId:0,
            //'service': 'Swamping/Lumping',
            'numberWorkers': 0,
            'date': new Date().toISOString().substr(0, 10),
            'startTime':null,
            'travelWorkers': [
            ],
            'travelDetail': {
                'idDetail':0,
                'po': '',
                'description': '',
                'truck': '',
                'trucking_Co':'',
                'trailer': '',
                containerSize:'',
                'driver': '',
                authorizedBy:'',
                OtherField:'',
                OtherFieldValue:''
            }
        },
        // tiem picker
        time: null,
        timePicker: false,
        modalTime: false,

        time2: null,
        timePicker2: false,
        modalTime2: false,
        //date Picker
        CurrentDate: new Date().toISOString().substr(0, 10),
        menu: false,
        modal: false,
        menu2: false,
        //table of workers
        dialog: false,
        serviceTypes:[],
        headers: [
            { text: 'User name', align: 'start', sortable: false, value: 'name',},
            { text: 'Hours', value: 'hours' },
            { text: 'Rate', value: 'rate' },
            { text: 'Start Time', value: 'startTime' },
            { text: 'Phone Number', value: 'phone' },
            { text: 'Actions', value: 'actions', sortable: false }
        ],
        desserts: [],
        editedIndex: -1,
        editedItem: {
            idTravelWorker:0,
            userId:'',
            userName: '',
            hours: 0,
            rate:0,
            name:'',
            startTime:'',
            phone:''
        },
        defaultItem: {
            userName: '',
            hours: 0,
            rate:0,
            startTime:'',
            phone:''
        },
      }
    },

    props:{
        dialogNewService: Boolean,
        seeService: Boolean,
        serviceInfo: Object,
        stateService: String
    },

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Add Lumper' : 'Edit Lumper'
      },
      textButtonWorker () {
          return this.editWorker === true ? 'UPDATE' : 'ADD'
      },
      textButtonSaveService () {
          return this.seeService === true ? 'UPDATE' : 'SAVE'
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
     
      seeService(val){         
          if(val === true){
                this.setServiceInformation()
                this.getAllLocations()
                this.getAllServiceTypes()
        }    
      },
      dialogNewService(val){
          if(val === true){
            this.getAllLocations()
            this.getAllCustomers()
            this.getAllServiceTypes();
          }
      }
    },

    methods: {
        updateStatTime(){
            this.serviceModel.travelWorkers.forEach(worker => worker.startTime = this.serviceModel.startTime)
        },
        setServiceInformation(){
            this.serviceModel = this.serviceInfo
            this.address = this.serviceInfo.customer.address
            this.phoneNumber = this.serviceInfo.customer.phoneNumer
            this.serviceModel.travelWorkers = this.serviceInfo.travelWorkers
            this.serviceType = this.serviceInfo.serviceType.name
            //console.log('workers => ', this.serviceInfo.travelWorkers)
        },
        async getAllLocations(){
            var locations = await this.$store.dispatch('getAllLocations')
            this.itemsLocation = locations.data
            this.service = 'Swamping/Lumping'
            this.serviceModel.date = new Date().toISOString().substr(0, 10)
        },
        openDialoAddWorker(){
            this.editedItem.startTime = this.serviceModel.startTime
            this.getAllWorkers()
            this.editWorker=false
        },
        selectWorker(){
            this.itemsWorkers.forEach(worker => {
                if(worker.id === this.editedItem.userId){
                    this.editedItem.phone= worker.phoneNumber
                    this.editedItem.userName= worker.userName
                    this.editedItem.name=worker.name
                }
            })
        },
        async getAllWorkers(){
            const response = await this.$store.dispatch('getAllWorkers')
            if(response.status ===200){
                //console.log('data ==> ', response.data)
                this.itemsWorkers=response.data
            }else{
                alert('An error was ocurred when try get all korkers')
            }
        },
        closeDialogNewService(){
            this.resetAllFields()
            this.serviceModel.travelWorkers=[]
            this.$emit('closeNewService')
        },
        async SaveService(){
            const validation = this.$refs.form2.validate()
            if(validation===true){
                if(this.seeService === true){
                    const response  = await this.$store.dispatch('updateService',this.serviceModel)
                    if(response.status === 200){
                        showMessageSuccess('GOOD!', 'Service updated correctly')
                        this.resetAllFields()
                        this.$emit('closeNewService')
                    }else{
                        showMessageError('An error has occurred')
                    }
                }else{
                    const response  = await this.$store.dispatch('createNewService',this.serviceModel)
                    if(response.status === 200){
                        showMessageSuccess('GOOD!', 'Service added successfully')
                        this.resetAllFields()
                        this.$emit('closeNewService')
                    }else{
                        showMessageError('An error has occurred')
                    }
                }
            }
        },
        resetAllFields(){
            this.e1=1
            this.$refs.form.reset()
            this.desserts=[]
            this.$refs.form2.reset()
        },
        toStep3(){
            this.e1 = 3
            this.serviceModel.numberWorkers = this.serviceModel.travelWorkers.length
            //console.log('model data ==> ',this.serviceModel)
        },
        toStep2(){
            var validation = this.$refs.form.validate()
            if(validation === true){
                //if (!this.seeService) this.serviceModel.travelWorkers=[]
                this.e1=2
                this.serviceModel.service = this.service
                //console.log('model data ==> ',this.serviceModel)
            }
        },
        selectCustomer(){
            this.items.forEach(item => {
                if(item.idCustomer === this.serviceModel.idCustomer){
                    this.address = item.address
                    this.phoneNumber = item.phoneNumer
                    this.postalCode = item.postalCode
                }
            })
        },
        
        selectService(){
            this.serviceTypes.forEach(s => {
                if(s.name == this.serviceType){
                    this.serviceModel.serviceTypeId = s.serviceTypeId
                }
            })
        },
        async getAllServiceTypes(){
            const response = await this.$store.dispatch ('getAllServiceTypes')
            if(response.status === 200){
                this.serviceTypes = response.data
            }
        },
        async getAllCustomers(){
            const date = await this.$store.dispatch('getCurrentDate')
            if(date === 200){
                this.CurrentDate = date.data
            }
            const response = await this.$store.dispatch('getAllCustomers')
            if(response.status === 200){
                this.items= response.data
            }else{
                alert('An error was ocurred when try charge all customers')
            }
        },
       
        
        //table of workers
        initialize () {
            this.desserts = []
        },

      editItem (item) {
        this.editedIndex = this.serviceModel.travelWorkers.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
        this.editWorker=true
      },

      deleteItem (item) {
        const index = this.serviceModel.travelWorkers.indexOf(item)
        confirm('Are you sure you want to delete this item?') && this.serviceModel.travelWorkers.splice(index, 1)
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.serviceModel.travelWorkers[this.editedIndex], this.editedItem)
        } else {
          this.serviceModel.travelWorkers.push(this.editedItem)
        }
        this.close()
      },
    },
}
</script>